import { Box, Button, Flex, Heading, Stack, Text, useBreakpointValue } from "@chakra-ui/react";
import useTranslation from "next-translate/useTranslation";
import { FiShield } from "react-icons/fi";

const SecurityAlertBanner = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const {t}=useTranslation();
  return (
    <Box 
      bgGradient="linear(to-r, #00a086, #008b74)"
      borderRadius="xl"
      p={{ base: 4, md: 5 }}
      color="white"
      boxShadow="md"
      borderLeftWidth="4px"
      borderLeftColor="#00d1a7"
      width="full" // Prend toute la largeur disponible
      maxWidth="100%" // Empêche le dépassement
      boxSizing="border-box" // Garde les dimensions incluant padding/border
    >
      <Stack
        
        align="start"
        gap={{ base: 3, md: 5 }}
        wrap="nowrap"
      >
        <Box fontSize={{ base: "2xl", md: "3xl" }} color="#00ffd0">
          <FiShield />
        </Box>

        <Box flex="1" minWidth="0">
          <Heading size={"sm"} mb={1}>
            {t("dashboard:security_vul_banner.title")}
          </Heading>
          <Text fontSize={"xs"} opacity={0.95}>
            {t("dashboard:security_vul_banner.description")}
            </Text>
        </Box>

        <Button
          bg="white"
          color="#008b74"
          size={"sm"}
          px={6}
          fontWeight="bold"
          rightIcon={<FiShield color="#00a086" />}
          _hover={{ 
            bg: "gray.50",
            transform: "scale(1.03)" 
          }}
          _active={{ bg: "gray.100" }}
          transition="all 0.2s"
          flexShrink={0} 
          onClick={() => window.location.href = "/pricing"} 
        >
          {t("dashboard:security_vul_banner.start_button")}
        </Button>
      </Stack>
    </Box>
  );
};

export default SecurityAlertBanner;